
/**
 * @file  popover浮层组件管理器
 * @author liudy
 */

import { $document } from '@umu/umu-dom';
import IPopover from './interface';

const DROPDOWN_MENU_MASK = 'dropdown-menu-mask';

class Manager {

    public static instance?: Manager;

    public static getManager() {
        if (!Manager.instance) {
            Manager.instance = new Manager();
        }
        return Manager.instance;
    }

    public currentPoppver?: IPopover | null;
    public list: IPopover[];

    constructor() {
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.bindDoc();
        this.list = [];
    }

    public destory() {
        this.unbindDoc();
    }

    public addComponents(popover: IPopover) {
        this.list.push(popover);
    }

    public removeComponents(popover: IPopover) {
        const index = this.list.indexOf(popover);
        this.list.splice(index, 1);
    }

    public hideAll() {
        this.list.map((item) => {
            item.hide();
        });
    }

    public showMask() {
        let mask = $document.querySelector(`.${DROPDOWN_MENU_MASK}`);
        if (!mask) {
            mask = $document.createElement('div');
            mask.classList.add(DROPDOWN_MENU_MASK);
            $document.body.appendChild(mask);
            mask.addEventListener('click', (evt: Event) => {
                this.onDocumentClick();
                evt.preventDefault();
                evt.stopPropagation();
            });
        }
        mask.classList.add('show');
    }

    public hideMask() {
        const mask = $document.querySelector(`.${DROPDOWN_MENU_MASK}`);
        if (mask) {
            mask.classList.remove('show');
            // mask.removeEventListener('click', this.onDocumentClick);
        }
    }

    private onDocumentClick() {
        this.list.map((item) => {
            if (this.currentPoppver === item) {
                this.currentPoppver = null;
                return;
            }
            item.hide();
        });
    }

    private unbindDoc() {
        ($document.documentElement || $document).removeEventListener('click', this.onDocumentClick);
    }

    private bindDoc() {
        ($document.documentElement || $document).addEventListener('click', this.onDocumentClick);
    }
}



export default Manager;

